import React from 'react';
import {
  Row, Col, Form, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import './DetailsEdit.scss';
import { getUserType } from '../../../../../../utils/users';
import PrnOxidoField from '../../../../serviceComponents/fieldComponents/prntOxido/PrntOxido';
import PrnCalcarioField from '../../../../serviceComponents/fieldComponents/prntCalcario/PrntCalcario';
import VDesejado from '../../../../serviceComponents/fieldComponents/vDesenjado/VDesejado';
import MaturadorField from '../../../../serviceComponents/fieldComponents/maturador/Maturador';
import NomeProdutoField from '../../../../serviceComponents/fieldComponents/nomeProduto/NomeProduto';
import TombamentoField from '../../../../serviceComponents/fieldComponents/tombamento/Tombamento';
import DataPlantioField from '../../../../serviceComponents/fieldComponents/dataPlantio/DataPlantio';
import EstagioCorte from '../../../../serviceComponents/fieldComponents/estagioCorte/EstagioCorte';
import VariedadeField from '../../../../serviceComponents/fieldComponents/variedade/Variedade';

const DetailsEdit = (props) => {
  const {
    formInstance, allRequestParams, initialValuesObject,
    edit, detail,
  } = props;

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="vantDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="vantDetails__FirstFieldColumn"
        >
          <VDesejado
            min={0}
            max={100}
            name="GEOFERT-ZONA_MANEJO-VANT-V_DESEJADO"
            rules={[]}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-VANT-V_DESEJADO']}
            edit={edit}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="vantDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="vantDetails__FirstFieldColumn"
        >
          <PrnCalcarioField
            min={0}
            max={100}
            name="GEOFERT-ZONA_MANEJO-VANT-PRNT_CALCARIO"
            rules={[]}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-VANT-PRNT_CALCARIO']}
            edit={edit}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="vantDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="vantDetails__FirstFieldColumn"
        >
          <PrnOxidoField
            min={130}
            max={180}
            name="GEOFERT-ZONA_MANEJO-VANT-PRNT_OXIDO"
            rules={[]}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-VANT-PRNT_OXIDO']}
            edit={edit}
          />
        </Col>
      </Row>

      {
        (
          allRequestParams?.landFields?.[0]?.culture === 'Cana açúc'
          || allRequestParams?.talhoesSelecionados?.[0]?.culture?.id === '051'
        )
        && (
          <Row
            gutter={[24, 24]}
            className="zonaManejoDetails__FirstFieldRow"
          >
            <Col
              xs={{ span: 24 }}
              className="zonaManejoDetails__FirstFieldColumn"
            >
              <VariedadeField
                name="GEOFERT-ZONA_MANEJO-VARIEDADE"
                label="Variedade"
                value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-VARIEDADE']}
                rules={[
                  {
                    required: true, message: 'O campo é obrigatório',
                  },
                ]}
                edit={edit}
              />
            </Col>
          </Row>
        )
      }

      {
        (
          allRequestParams?.landFields?.[0]?.culture === 'Cana açúc'
          || allRequestParams?.talhoesSelecionados?.[0]?.culture?.id === '051'
        )
        && (
          <Row
            gutter={[24, 24]}
            className="zonaManejoDetails__FirstFieldRow"
          >
            <Col
              xs={{ span: 24 }}
              className="zonaManejoDetails__FirstFieldColumn"
            >
              <EstagioCorte
                min={1}
                max={20}
                name="GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE"
                nameData1="GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE"
                nameData2="GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE"
                label="Estágio de corte"
                labelData1="Data do último corte"
                labelData2="Data do penúltimo corte"
                date1min="2"
                date2min="3"
                edit={edit}
                estagioCorteValue={initialValuesObject?.['GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE']}
                dataUltimoCorte={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE']}
                dataPenultimoCorte={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE']}
                rules={[
                  {
                    required: true, message: 'Por favor, insira um valor entre 1 e 20',
                  },
                ]}
                rulesData1={edit === false
                  ? [
                    {
                      required: true, message: 'O campo é obrigatório',
                    },
                    {
                      validator: (b, value) => {
                        const finalDate = moment().format('DD/MM/YYYY');
                        const dateFormat = 'DD/MM/YYYY';

                        if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                          return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]
                  : null}
                rulesData2={edit === false
                  ? [
                    {
                      required: true, message: 'O campo é obrigatório',
                    },
                    {
                      validator: (b, value) => {
                        const finalDate = moment().format('DD/MM/YYYY');
                        const dateFormat = 'DD/MM/YYYY';

                        if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                          return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]
                  : null}
              />
            </Col>
          </Row>
        )
      }

      <Row
        gutter={[24, 24]}
        className="vantDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="vantDetails__FirstFieldColumn"
        >
          <DataPlantioField
            name="GEOFERT-ZONA_MANEJO-DATA_PLANTIO"
            label="Data de plantio"
            edit={edit}
            rules={edit === false
              ? [
                {
                  required: true, message: 'O campo é obrigatório',
                },
                {
                  validator: (b, value) => {
                    const finalDate = moment().format('DD/MM/YYYY');
                    const dateFormat = 'DD/MM/YYYY';

                    if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                      return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                    }

                    return Promise.resolve();
                  },
                },
              ]
              : null}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_PLANTIO']}
          />
        </Col>
      </Row>

      {
        (
          allRequestParams?.landFields?.[0]?.culture === 'Cana açúc'
          || allRequestParams?.talhoesSelecionados?.[0]?.culture?.id === '051'
        )
        && (
          <Row
            gutter={[24, 24]}
            className="zonaManejoDetails__FirstFieldRow"
          >
            <Col
              xs={{ span: 24 }}
              className="zonaManejoDetails__FirstFieldColumn"
            >
              <TombamentoField
                name="GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO"
                label="Houve tombamento?"
                nameData="GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO"
                labelData="Data de tombamento"
                edit={edit}
                formInstance={formInstance}
                rules={[]}
                value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO']}
                valueData={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO']}
                rulesData={edit === false
                  ? [
                    {
                      validator: (b, value) => {
                        const finalDate = moment().format('DD/MM/YYYY');
                        const dateFormat = 'DD/MM/YYYY';

                        if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                          return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]
                  : null}
              />
            </Col>
          </Row>
        )
      }

      {
        (
          allRequestParams?.landFields?.[0]?.culture === 'Cana açúc'
          || allRequestParams?.talhoesSelecionados?.[0]?.culture?.id === '051'
        )
        && (
          <Row
            gutter={[24, 24]}
            className="zonaManejoDetails__FirstFieldRow"
          >
            <Col
              xs={{ span: 24 }}
              className="zonaManejoDetails__FirstFieldColumn"
            >
              <MaturadorField
                name="GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR"
                label="Houve aplicação de maturador?"
                nameData="GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR"
                labelData="Data da aplicação de maturador"
                edit={edit}
                rules={[]}
                formInstance={formInstance}
                value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR']}
                valueData={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR']}
                rulesData={edit === false
                  ? [
                    {
                      validator: (b, value) => {
                        const finalDate = moment().format('DD/MM/YYYY');
                        const dateFormat = 'DD/MM/YYYY';

                        if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                          return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]
                  : null}
              />
            </Col>
          </Row>
        )
      }
      {
        (
          allRequestParams?.landFields?.[0]?.culture === 'Cana açúc'
          || allRequestParams?.talhoesSelecionados?.[0]?.culture?.id === '051'
        )
        && (
          <Form.Item
            noStyle
            shouldUpdate={
              (previousValues, currentValues) => {
                return currentValues['GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR']
                  !== previousValues['GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR'];
              }
            }
          >
            {
              (formInstanceParameter) => {
                if (
                  formInstanceParameter.getFieldValue('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR') === true
                  || formInstanceParameter.getFieldValue('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR') === 'true'
                ) {
                  return (
                    <Row
                      gutter={[24, 24]}
                      className="zonaManejoDetails__FirstFieldRow"
                    >
                      <Col
                        xs={{ span: 24 }}
                        className="zonaManejoDetails__FirstFieldColumn"
                      >
                        <NomeProdutoField
                          name="GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR"
                          label="Nome do produto utilizado"
                          rules={[]}
                          edit={edit}
                          value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR']}
                        />
                      </Col>
                    </Row>
                  );
                }

                return null;
              }
            }
          </Form.Item>
        )
      }

      {
        getUserType() === 'COOPERCITRUS' && !detail
        && (
          <>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }}>
                <hr />
                <p className="vantDetails__SessionTitle">Orçamento</p>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="vantDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="vantDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Valor unitário</span>}
                  name="GEOFERT-ZONA-MANEJO-VANT-VALOR_UNITARIO"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-ZONA-MANEJO-VANT-VALOR_UNITARIO']
                        ? initialValuesObject['GEOFERT-ZONA-MANEJO-VANT-VALOR_UNITARIO'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="vantDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="vantDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Valor total</span>}
                  name="GEOFERT-ZONA-MANEJO-VANT-VALOR_TOTAL"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-ZONA-MANEJO-VANT-VALOR_TOTAL']
                        ? initialValuesObject['GEOFERT-ZONA-MANEJO-VANT-VALOR_TOTAL'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="vantDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="vantDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Condição de pagamento</span>}
                  name="GEOFERT-ZONA-MANEJO-VANT-CONDICAO_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-VANT-CONDICAO_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="vantDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="vantDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Forma de pagamento</span>}
                  name="GEOFERT-ZONA-MANEJO-VANT-FORMA_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-VANT-FORMA_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="vantDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="vantDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Observações do orçamento</span>}
                  name="GEOFERT-ZONA-MANEJO-VANT-OBSERVACOES"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-VANT-OBSERVACOES']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )
      }

    </>
  );
};

DetailsEdit.propTypes = {
  formInstance: PropTypes.shape({}).isRequired,
  initialValuesObject: PropTypes.shape({
    'GEOFERT-ZONA_MANEJO-VANT-PRNT_OXIDO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-VANT-PRNT_CALCARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-VANT-V_DESEJADO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR': PropTypes.oneOfType([PropTypes.oneOf(['true', 'false']), PropTypes.bool]),
    'GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR': PropTypes.string,
    'GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO': PropTypes.oneOf(['true', 'false']),
    'GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-DATA_PLANTIO': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-VARIEDADE': PropTypes.string,
    'GEOFERT-ZONA-MANEJO-VANT-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-VANT-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-VANT-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-VANT-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-VANT-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
  allRequestParams: PropTypes.shape({
    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        culture: PropTypes.shape({
          id: PropTypes.string,
        }),
      }),
    ),

    landFields: PropTypes.arrayOf(
      PropTypes.shape({
        culture: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};
DetailsEdit.defaultProps = {
  detail: false,
};

export default DetailsEdit;
